import { ToastOptions } from '@chakra-ui/react';

import { MessageStatus } from './MessageStatus';

export const MESSAGE_STATUS_TOAST_MAP: Record<
  MessageStatus,
  ToastOptions['type']
> = {
  [MessageStatus.Success]: 'success',
  [MessageStatus.Error]: 'error',
  [MessageStatus.Warning]: 'warning',
  [MessageStatus.Info]: 'info',
} as const;
